<template>
    <LayoutBase role="status">
        <template #title>{{ t("title") }}</template>

        <template #description>
            {{ t("desctiption") }}
        </template>

        <div class="row row_top-m">
            <UiButton class="full-width" size="lg" @click="router.push({ name: 'login' })">
                {{ t("signIn") }}
            </UiButton>
        </div>
    </LayoutBase>
</template>

<script lang="ts" setup>
import LayoutBase from '@/components/layouts/LayoutBase.vue';

import { onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';

const { t } = useI18n();

const { logout } = useAuthStore()

const router = useRouter();

onBeforeMount(() => logout());
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
</style>

<i18n locale="ru_RU" lang="json">
{
  "title": "Ваш\u00a0пароль\u00a0изменён!",
  "desctiption": "Для входа в систему необходимо ввести новый пароль",
  "signIn": "Войти"
}
</i18n>

<i18n locale="en_GB" lang="json">
{
  "title": "Your password has been changed!",
  "desctiption": "You must enter a new password to sign in",
  "signIn": "Sign in"
}
</i18n>

<i18n locale="es_ES" lang="json">
{
  "title": "La contraseña ha sido cambiada!",
  "desctiption": "Para entrar en el sistema, tienes que ingresar nueva contraseña",
  "signIn": "Entrar"
}
</i18n>
